import { useRef, useEffect } from 'react';
import { Enter } from '../../../utils/keycode.js';

const useInputElement = ({
  autoFitWidth,
  onValueChange,
  value,
  onKeyDown,
  onPressEnter
}) => {
  const refInput = useRef();
  const refInputMirror = useRef();
  const refPrevInputWidth = useRef(null);
  const updateInputWidth = () => {
    if (refInputMirror.current && refInput.current) {
      const width = refInputMirror.current.offsetWidth;
      refInput.current.style.width = `${width + (width ? 8 : 4)}px`;
    }
  };
  useEffect(() => autoFitWidth && updateInputWidth(), []);
  const tryTriggerValueChangeCallback = (newValue, e) => {
    if (onValueChange &&
    // Avoid triggering onChange repeatedly for the same value
    newValue !== value) {
      onValueChange(newValue, e);
    }
  };
  const onChange = e => {
    const newValue = e.target.value;
    tryTriggerValueChangeCallback(newValue, e);
  };
  const handleOnKeyDown = e => {
    const keyCode = e.keyCode || e.which;
    onKeyDown && onKeyDown(e);
    if (keyCode === Enter.code) {
      onPressEnter && onPressEnter(e);
    }
  };
  return {
    refInput,
    refInputMirror,
    refPrevInputWidth,
    tryTriggerValueChangeCallback,
    onChange,
    handleOnKeyDown,
    updateInputWidth
  };
};

export { useInputElement };
